import { render, staticRenderFns } from "./appError.vue?vue&type=template&id=5c1a25d6&scoped=true"
import script from "./appError.vue?vue&type=script&lang=js"
export * from "./appError.vue?vue&type=script&lang=js"
import style0 from "./appError.vue?vue&type=style&index=0&id=5c1a25d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1a25d6",
  null
  
)

export default component.exports